import { defineMessages } from 'react-intl';

export default defineMessages({
    choose: {
        id: 'ent.platform.questionsets.question-set --Please Select--', // DE15926
        defaultMessage: ' --Please Select--'
    },
    required: {
        id: 'ent.gw-portals-questionsets-js.answer.validation.This is a required field',
        defaultMessage: 'This is a required field.'
    },
    invalidCharacter: {
        id: 'ent.gw-portals-questionsets-js.answer.validation.An invalid character was entered, such as a letter in a numeric field',
        defaultMessage: 'An invalid character was entered, such as a letter in a numeric field.'
    },
    pageTitle: {
        id: 'ent.quoteandbind.views.prequal-questions.Qualification',
        defaultMessage: 'Qualification'
    },
    typeListPlaceholder: {
        id: 'ent.platform.digital-modules-ui.gw-portals-questionsets-js. --Please Select--',
        defaultMessage: ' --Please Select--'
    }
});
